import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=4fdd36d2"
import script from "./Puzzle.vue?vue&type=script&lang=js"
export * from "./Puzzle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports